export default [
  {
    path: 'afiliados/carteira',
    name: 'carteira',
    component: () => import('./index'),
    children: [],
    meta: {
      visible: true,
      title: 'Carteira',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Afiliados', link: 'afiliados' },
        { name: 'Carteira' },
      ]
    }
  },
]